var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-btn',{nativeOn:{"click":function($event){return _vm.toggleTheme.apply(null, arguments)}}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.themeIcon)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }